import { Group, Layout, Page, Tree } from "@/comn/components";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, usePage, useResource, useStore, useTheme, useToast, useTree } from "@/comn/hooks";
import { SF_MENU_SCRN_SRCH, URLS } from "@/tz/go/egaz/osci/ptl/ptl/menuscrn/services/OsciMenuScrnService";
import * as menuService from "@/tz/go/egaz/osci/ptl/ptl/menu/services/OsciMenuService";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/*
 * Select Menu and Screen List
 * !== 메뉴 연결 목록 ==!
 */
export const OSCI0104007Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const { setStore, getStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const tree = useTree();
    const { theme } = useTheme();
    const navigate = useNavigate();

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const form = {
        menuSrch: useForm({ defaultSchema: SF_MENU_SCRN_SRCH }),
    };

    const fetch = {
        getMenuList: useFetch({
            api: (data: any = form.menuSrch.getValues()) => menuService.APIS.getMenuList(data),
            onSuccess: (data) => {
                const menuList = data["menuList"].content;

                tree.setData([
                    {
                        name: "ROOT",
                        menuId: "menu_root",
                        menuPath: "ROOT",
                        children: handler.createTreeData(menuList, [], 1, "menu_root"),
                    },
                ]);

                tree.openTree();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // 조회가 실패하였습니다.
        }),
    };

    const handler = {
        onClear: () => {
            form.menuSrch.clearValues();
            form.menuSrch.setValues({ bsopClsfCd: "OSC", ptlTpCd: "O" });
            tree.setData([]);
        },
        goDetail: () => {
            if (comnUtils.isEmpty(form.menuSrch.getValue("menuId"))) {
                modal.openModal({ content: "msg.osc.00196" }); // Please select the menu. !== 메뉴를 선택하세요. ==!
                return;
            }

            navigate(`${URLS.osci0104008s}/${form.menuSrch.getValue("menuId")}`, {
                state: { ptlTpCd: form.menuSrch.getValue("ptlTpCd") },
            });
        },
        onTreeRowClick: (treeInfo: any) => {
            const { children, menuPath, menuId } = treeInfo;

            if (!comnUtils.isEmptyArray(children)) {
                modal.openModal({ content: "msg.osc.00198" });
                return;
            }

            form.menuSrch.setValue("menuId", menuId);
            form.menuSrch.setValue("menuPath", menuPath);
        },
        onMenuScrhBtnClick: () => {
            form.menuSrch.setValue("menuId", "");
            form.menuSrch.setValue("menuPath", "");

            setStore(pgeUid, form.menuSrch.getValues());

            form.menuSrch.handleSubmit(
                () => fetch.getMenuList.fetch(),
                () => toast.showToast({ type: "warning", content: "msg.osc.00194" }), // 조회 조건 필수 입력 항목을 입력하시기 바랍니다.
            )();
        },
        createTreeData: (orgList: any, newList: any, level: any, menuId: any) => {
            const tempList = orgList
                .map((item: any) => {
                    return {
                        name: comnUtils.replaceEmpty(item.menuNm),
                        checkbox: false,
                        menuId: comnUtils.replaceEmpty(item.menuId),
                        menuNm: comnUtils.replaceEmpty(item.menuNm),
                        menuLvl: comnUtils.replaceEmpty(item.menuLvl, 0),
                        menuOrd: comnUtils.replaceEmpty(item.menuOrd, 0),
                        uprMenuId: comnUtils.replaceEmpty(item.uprMenuId),
                        uprMenuNm: comnUtils.replaceEmpty(item.uprMenuNm),
                        menuPath: comnUtils.replaceEmpty(item.menuPath),
                    };
                })
                .filter((item: any) => item["menuLvl"] === level && item["uprMenuId"] === menuId);

            if (tempList.length === 0) return newList;

            tempList.forEach((item: any) => {
                if (!item.children) item.children = [];
                handler.createTreeData(orgList, item.children, item["menuLvl"] + 1, item["menuId"]);
                newList.push(item);
            });

            return newList;
        },
    };

    useEffect(() => {
        // Service Category, Portal Type 은 고정값이므로 수정할 수 없도록 한다.
        form.menuSrch.setEditable("bsopClsfCd", false);
        form.menuSrch.setEditable("ptlTpCd", false);

        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store)) {
            form.menuSrch.setValues(store);
            fetch.getMenuList.fetch();
        }
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.menuSrch.schema.ptlTpCd} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section>
                        <Layout>
                            <Layout.Left>
                                <Layout.Button role={"reset"} onClick={handler.onClear} />
                            </Layout.Left>
                            <Layout.Right>
                                <Layout.Button role={"search"} onClick={handler.onMenuScrhBtnClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Header>
                    <Group.Title title={"T_MENU_LIST"} />
                </Group.Header>
                <Group.Body>
                    <Tree {...tree.tree} defaultOpen={true} height={250} size={12} onClick={handler.onTreeRowClick} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuSrch.schema.menuPath} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Right>
                            <Layout.Button onClick={handler.goDetail}>{t("L_MENU_SCRN_CNCT")}</Layout.Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
